import { CustomScript } from './custom-script.js'
import { DateFormatting } from './date-formatting.js'
import { JsonQuery } from './json-query.js'
import { RangeMapping } from './range-mapping.js'
import { ValueMapping } from './value-mapping.js'
import { TextTransform } from './text-transform.js'
import { StringManipulation } from './string-manipulation.js'
import { Passthrough } from './passthrough.js'

export const FunctionList = [
  Passthrough,
  CustomScript,
  DateFormatting,
  JsonQuery,
  TextTransform,
  StringManipulation,
  ValueMapping,
  RangeMapping
]
